<body>
  <div class="first-background">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="logo">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(dec-13)/image/logo.png"
              alt="logo"
            />
          </div>
        </div>
        <div class="col-lg-8 text-right">
          <div class="social-img">
            <a
              href="https://onpassive.com/blog"
              target="_blank"
              rel="noopener"
              title="ONPASSIVE Blog"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-13)/image/icon/blog3.png"
                class="blog-icon"
                alt="blog3"
              />
            </a>
            <a
              href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Facebook"
            >
              <img
                src="{{ onPassiveBaseUrl }}onpassive(dec-13)/image/icon/fb.png"
                alt="Facebook"
              />
            </a>
            <a
              href="https://twitter.com/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Twitter"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-13)/image/icon/twitter.png"
                alt="Twitter"
              />
            </a>
            <a
              href="https://www.instagram.com/ONPASSIVE/"
              target="_blank"
              rel="noopener"
              title="Instagram"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-13)/image/icon/insta.png"
                alt="Instagram"
              />
            </a>
            <a
              href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
              target="_blank"
              rel="noopener"
              title="Youtube"
            >
              <img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(dec-13)/image/icon/youtube.png"
                alt="YouTube"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
              target="_blank"
              rel="noopener"
            >
              <img
                src="{{ onPassiveBaseUrl }}onpassive(nov-30)/images/in.png"
                title="Linkedin"
                alt="LinkedIn"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="line"></div>
  <section class="second-background">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 mt-5">
          <h2 class="font-10 p-2">LAUNCHING SOON</h2>
          <div class="video-box">
            <video
              id="my-video"
              class="
                video-js video-size
                w-100
                h-auto
                my-video-dimensions
                shadow
              "
              controls
              preload="auto"
              poster="{{ myLinksS3URL }}images/Image0231.png"
              data-setup="{}"
              autoplay="true"
              muted
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
        <div class="col-lg-3"></div>
        <div class="col-lg-4"></div>
      </div>
    </div>
  </section>
  <section class="third-background">
    <div class="container">
      <div class="row mt-5">
        <div class="col-lg-12">
          <div class="row mt-3">
            <div class="col-lg-12 text-center">
              <p class="font-para">
                We at ONPASSIVE aim for excellence, not just perfection. With
                the help of one of the most influential technologies of this
                decade - Artificial Intelligence, we are establishing a powerful
                business opportunity that is entirely flawless. With the fine
                blend of AI and marketing, we are going to set an example in the
                marketing world. Be a part of us to be a part of excellence.
              </p>

              <a
                href="/registration/user?reg={{ userId }}"
                name="regform"
                target="_blank"
                rel="noopener"
              >
                <div class="btn">BECOME A FOUNDER NOW</div>
              </a>
              <div class="copy-right">
                <p>&copy; 2022 ONPASSIVE - All Rights Reserved</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!---------------------------Section End--------------------------------------------------------->
</body>
